import React from 'react';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices,
    Create, SimpleForm, TextInput, DateInput,
    ImageInput, ImageField, ReferenceInput, SelectInput,
    BooleanInput, NumberInput
} from 'react-admin';
import { useStyles } from "../../formStyles";
import RichTextInput from 'ra-input-rich-text';
import { parse } from "query-string";
import {CreateToolbar} from "../../CreateToolbar";

export const ModuleCreate = props => {
    const classes = useStyles({});
     
    return (
        <Create {...props} title="Add Scoring Type">
            <SimpleForm variant="outlined"  toolbar={<CreateToolbar {...props}/>}
            
            redirect={"list"}
            >
            <TextInput source="code"  validate={required()} fullwidth={true} />
            <TextInput source="name"  validate={required()} fullwidth={true}/>
            <BooleanInput initialValue={true} source="isActive" validate={required()}  label="Active" />
            </SimpleForm>
        </Create>
    );
}